import React, {useEffect} from 'react';
import {Col, Container, Row} from 'reactstrap';

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

import {EffectFade, Autoplay} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import "../../assets/scss/custom.css";

// Import Images
import imgpattern from "../../assets/images/landing/img-pattern.png";
import slide1 from "../../assets/images/app/slide1.jpg";
import slide2 from "../../assets/images/app/slide2.jpg";
import slide3 from "../../assets/images/app/slide3.jpg";
import slide4 from "../../assets/images/app/slide4.jpg";

import slideLight1 from "../../assets/images/app/slide-light-1.jpg";
import slideLight2 from "../../assets/images/app/slide-light-2.jpg";
import slideLight3 from "../../assets/images/app/slide-light-3.jpg";
import slideLight4 from "../../assets/images/app/slide-light-4.jpg";

import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../config';
import {changeLayoutMode} from "../../store/layout/query";

const Home = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const layoutModeType = useSelector(state => state.Layout.layoutModeType);

    useEffect(() => {
        if (
            layoutModeType
        ) {
            dispatch(changeLayoutMode(layoutModeType));
        }
    }, [
        layoutModeType,
        dispatch]);

    return (
        <section className="section pb-0 hero-section hero-class" id="hero">
            <div className="bg-overlay bg-overlay-pattern"></div>
            <Container>
                <Row className="justify-content-center">
                    <Col lg={9} sm={10}>
                        <div className="text-center mt-lg-5 pt-5">
                            <h1 className="display-6 fw-semibold mb-3 lh-base">
                                {t('t-app-desc').split('{appName}')[0]}
                                <span className="text-primary">{appConfig.appName}</span>
                                {t('t-app-desc').split('{appName}')[1]}
                            </h1>
                            <p className="lead text-muted lh-base">
                                {t('t-app-desc-long').split('{appName}')[0]}
                                <span className="fw-semibold">{appConfig.appName}</span>
                                {t('t-app-desc-long').split('{appName}')[1]}.
                            </p>
                        </div>

                        <div className='mt-4 mt-sm-5 pt-sm-5 mb-sm-n5 demo-carousel'>
                            <div className="demo-img-patten-top d-none d-sm-block">
                                <img src={imgpattern} className="d-block img-fluid" alt="..."/>
                            </div>
                            <div className="demo-img-patten-bottom d-none d-sm-block">
                                <img src={imgpattern} className="d-block img-fluid" alt="..."/>
                            </div>

                            {layoutModeType !== 'light' ?
                                <Swiper
                                    spaceBetween={30}
                                    effect={"fade"}
                                    loop={true}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    autoplay={{delay: 3000, disableOnInteraction: false}}
                                    modules={[EffectFade, Autoplay]}
                                    className="mySwiper">

                                    <SwiperSlide className="carousel-inner shadow-lg p-1 bg-white rounded">
                                        <img src={slide1} className="d-block w-100" alt="..."/>
                                    </SwiperSlide>
                                    <SwiperSlide className="carousel-inner shadow-lg p-1 bg-white rounded">
                                        <img src={slide2} className="d-block w-100" alt="..."/>
                                    </SwiperSlide>
                                    <SwiperSlide className="carousel-inner shadow-lg p-1 bg-white rounded">
                                        <img src={slide3} className="d-block w-100" alt="..."/>
                                    </SwiperSlide>
                                    <SwiperSlide className="carousel-inner shadow-lg p-1 bg-white rounded">
                                        <img src={slide4} className="d-block w-100" alt="..."/>
                                    </SwiperSlide>
                                </Swiper> :
                                <Swiper
                                    spaceBetween={30}
                                    effect={"fade"}
                                    loop={true}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    autoplay={{delay: 3000, disableOnInteraction: false}}
                                    modules={[EffectFade, Autoplay]}
                                    className="mySwiper">

                                    <SwiperSlide className="carousel-inner shadow-lg p-1 bg-white rounded">
                                        <img src={slideLight1} className="d-block w-100" alt="..."/>
                                    </SwiperSlide>
                                    <SwiperSlide className="carousel-inner shadow-lg p-1 bg-white rounded">
                                        <img src={slideLight2} className="d-block w-100" alt="..."/>
                                    </SwiperSlide>
                                    <SwiperSlide className="carousel-inner shadow-lg p-1 bg-white rounded">
                                        <img src={slideLight3} className="d-block w-100" alt="..."/>
                                    </SwiperSlide>
                                    <SwiperSlide className="carousel-inner shadow-lg p-1 bg-white rounded">
                                        <img src={slideLight4} className="d-block w-100" alt="..."/>
                                    </SwiperSlide>
                                </Swiper>
                            }
                        </div>
                    </Col>
                </Row>
            </Container>

            <div className="position-absolute start-0 end-0 bottom-0 hero-shape-svg">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                     viewBox="0 0 1440 120">
                    <g mask="url(&quot;#SvgjsMask1003&quot;)" fill="none">
                        <path d="M 0,118 C 288,98.6 1152,40.4 1440,21L1440 140L0 140z">
                        </path>
                    </g>
                </svg>
            </div>

        </section>
    );
};

export default Home;